import { db } from '@/config/firebase';
import config from '@/config/env-constants';
import _ from 'lodash';

async function getActiveRepairsByAssetTypeName(assetType) {
    let repairsObj = {};

    const dbRef = db.collection("assetRepairTasks")
        .where("assetType", "==", assetType)
        .where("status", "!=", config.repairStatus.CANCELLED);

    const querySnapshots = await dbRef.get();

    querySnapshots.forEach(doc => {
        const id = doc.id;
        let repairObj = doc.data();
        repairsObj[id] = {
            id: id,
            ...repairObj
        }
    });

    return repairsObj;
}

function getRepairListener(filter, callback) {
    let query = generateQuery(filter);
    let listener = query.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
            let repair = change.doc.data();
            repair.id = change.doc.id;

            callback(change.type, repair);
        });
    });
    return listener;
}

function generateQuery(filter) {
    let query = db.collection("assetRepairTasks");

    if (filter.fromTimestamp && filter.fromTimestamp > 0) {
        query = query.where("dateCreated", ">=", filter.fromTimestamp);
    }

    if (filter.toTimestamp && filter.toTimestamp > 0) {
        query = query.where("dateCreated", "<=", filter.toTimestamp);
    }

    if (filter.status && filter.status.length > 0) {
        query = query.where("status", "==", filter.status);
    }

    if (filter.assetType.id && filter.assetType.id.length > 0) {
        query = query.where("assetType", "==", filter.assetType.name);
    }

    if (filter.assetCode && filter.assetCode.length > 0) {
        query = query.where("assetDetails.assetCode", "==", filter.assetCode);
    }

    if (filter.repairId && filter.repairId.length > 0) {
        query = query.where("repairTaskId", "==", filter.repairId);
    }

    if (!filter.isSuperAdmin) {
        // Added for filtering company view only but not on Filter Options
        if (filter.companyIds && !_.isEmpty(filter.companyIds)) {
            query = query.where("companyId", "in", filter.companyIds);
        }
    }

    return query;
}

export default {
    getActiveRepairsByAssetTypeName,
    getRepairListener,
}